import { MouseEvent, useContext } from 'react';
import { ModalContext } from 'src/contexts/ModalContext';

import * as styles from './AdCampaignsToolbar.css';
import {
  AdCampaignsToolbarDiv,
  FilterBarLeftSide,
  FilterBarRightSide,
} from './AdCampaignsToolbar.styled';

export type AdCampaignsToolbarType = {
  disabled?: boolean;
  onColumnSettingButtonClickHandler?: (
    e: MouseEvent<HTMLButtonElement>
  ) => void;
};

export function AdCampaignsToolbar() {
  const { setModal } = useContext(ModalContext);

  return (
    <AdCampaignsToolbarDiv className={styles.adCampaignsFilterBar}>
      <FilterBarLeftSide />
      <FilterBarRightSide></FilterBarRightSide>
    </AdCampaignsToolbarDiv>
  );
}
